"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
// @ts-ignore
function getTouchedForValues(values) {
    tiny_invariant_1.default(values, "getTouchedForValues(...) required parameter 'values' and is null or undefined.");
    tiny_invariant_1.default(typeof values === 'object', "getTouchedForValues(...) parameter 'values' is not an object.");
    var toucheObj = function (obj) {
        return Object.entries(obj).reduce(function (r, _a) {
            var _b, _c, _d;
            var _e = __read(_a, 2), k = _e[0], v = _e[1];
            if (Array.isArray(v)) {
                return __assign(__assign({}, r), (_b = {}, _b[k] = v.map(function (i) { return (i && typeof i === 'object' ? toucheObj(i) : true); }), _b));
            }
            if (v && typeof v === 'object') {
                return __assign(__assign({}, r), (_c = {}, _c[k] = toucheObj(v), _c));
            }
            return __assign(__assign({}, r), (_d = {}, _d[k] = true, _d));
        }, {});
    };
    return toucheObj(values);
}
exports.default = getTouchedForValues;
//# sourceMappingURL=getTouchedForValues.js.map